const withQueryParams = (queryFn) => (queryContext) => {
  const { queryKey, signal } = queryContext;
  if (Array.isArray(queryKey)) {
    const [, ...params] = queryKey;
    return queryFn(...params, signal);
  }
  return queryFn(queryKey, signal);
};
export {
  withQueryParams
};
